import { render, staticRenderFns } from "./CusPlayer.vue?vue&type=template&id=47c36233&"
import script from "./CusPlayer.vue?vue&type=script&lang=js&"
export * from "./CusPlayer.vue?vue&type=script&lang=js&"
import style0 from "./CusPlayer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports